import React, { Component } from 'react'
import './App.css'
import Main from './Main'
import SiderForm from './component/SiderForm'
import { Layout } from 'antd'
const { Content } = Layout

export default class App extends Component {
    render() {
        return (
            <div className="App">
                <header className="App-header">
                    <Layout>
                        <SiderForm />
                        <Layout>
                            <Content style={{ margin: '3vh 2vh' }}>
                                <div className="site-layout-background" style={{ padding: 24, minHeight: 'calc(100vh - 6vh)' }}>
                                    <Main />
                                </div>
                            </Content>
                        </Layout>
                    </Layout>
                </header>
            </div>
        )
    }
}
